import { ConfigInterface, responseInterface } from 'swr';
import { wpApi, useWPApi, parseUrl, api, useApi } from '@gik/core/api';
import WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';
import { apiCap } from '..';

const path = 'users';

function getParams() {
  return {
    type: 'articles',
    per_page: apiCap,
  };
}

export async function getSavedArticles(userId: string) {
  const finalUrl = parseUrl(`${path}/${userId}`, {
    searchParams: getParams(),
  });
  const ids = (await (await api.get(finalUrl)).json()) as string[];

  if (ids.length > 0) {
    const response = await wpApi.get(`posts?include=${ids.join(',')}`);
    return await response.json();
  } else {
    return [];
  }
}

// TODO: this should fetch from a single endpoint so simplify revalidation
export function useSavedArticles<Data = WordpressPost[], Error = WordpressError>(
  userId?: string,
  config?: ConfigInterface
): responseInterface<Data, Error> {
  const {
    data: ids,
    revalidate: revalidateFavorites,
    isValidating: isValidatingFavorites,
    mutate: mutateFavorites,
  } = useApi<string[]>(userId ? `${path}/${userId}/favorites` : null, config, {
    searchParams: getParams(),
  });

  const {
    data: articles,
    revalidate: revalidateArticles,
    isValidating: isValidatingArticles,
    mutate: mutateArticles,
  } = useWPApi<Data, Error>(ids && ids.length > 0 ? `posts` : null, config, {
    searchParams: {
      include: ids?.join(','),
    },
  });

  return {
    data: (ids?.length > 0 ? articles : []) as Data,
    isValidating: isValidatingFavorites || isValidatingArticles,
    revalidate: async () => {
      const result1 = await revalidateFavorites();
      const result2 = await revalidateArticles();
      return result1 && result2;
    },
    mutate: async () => {
      await mutateFavorites(ids, true);
      const response = await mutateArticles(articles, true);
      return response;
    },
  };
}
